export const SCHEDULE_TYPE_MAP = {
  minute: "Every Minute",
  hourly: "Every Hour",
  daily: "Every Day",
  weekly: "Every Week Sunday Night",
  monthly: "Every Month",
};

export const formatScheduleTime = (timeStr) => {
  if (!timeStr) return "";
  const str = String(timeStr).trim();
  if (!str) return "";

  // Check if it's already in 12-hour format e.g. "10:30 AM", "2:05 PM", "12:00 AM"
  const match12 = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)$/i);
  if (match12) {
    let hours = parseInt(match12[1], 10);
    const minutes = match12[2];
    const ampm = match12[3].toUpperCase();
    const formattedHours = String(hours).padStart(2, "0");
    return `${formattedHours}:${minutes} ${ampm}`;
  }

  // Check if it's in 24-hour format e.g. "14:30:00", "09:15:00", "14:30"
  const match24 = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (match24) {
    let hours = parseInt(match24[1], 10);
    const minutes = match24[2];
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");
    return `${formattedHours}:${minutes} ${ampm}`;
  }

  return str;
};

export const getEventDisplay = (workflow) => {
  if (!workflow || !workflow.event_type) return "-";
  const eventType = String(workflow.event_type).trim().toLowerCase();

  if (eventType === "insert") {
    return "Everytime Record is Saved";
  }

  if (eventType === "update") {
    return "Everytime Record is Modified";
  }

  if (eventType === "schedule") {
    const parts = ["Schedule"];
    const scheduleKey = (workflow.scheduletype || "").trim().toLowerCase();
    const scheduleName = SCHEDULE_TYPE_MAP[scheduleKey] || workflow.scheduletype;
    if (scheduleName) {
      parts.push(scheduleName);
    }
    const formattedTime = formatScheduleTime(workflow.scheduletime);
    if (formattedTime) {
      parts.push(formattedTime);
    }
    return parts.join(" - ");
  }

  return workflow.event_type || "-";
};
